export default __webpack_public_path__ + "static/orange-matrix-cf0b1633cf2cfe1be3536c97a33f58ac.webp";